import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-table-operations',
    templateUrl: './table-operations.component.html',
    styles: [
        `
      a {
        &:hover {
          color: initial !important;
        }
      }
    `,
    ],
    standalone: false
})
export class TableOperationsComponent {
  @Input('model') input_model: any;
  @Input('isShowEditBtn') input_isShowEditBtn: boolean = true;
  @Input('isShowDeleteBtn') input_isShowDeleteBtn: boolean = true;
  @Input('isShowDetailsBtn') input_isShowDetailsBtn: boolean = false;

  @Output('onUpdate') output_editModel: any = new EventEmitter<any[]>();
  @Output('onDelete') output_deleteModel: any = new EventEmitter<any[]>();
  @Output('onDetail') output_detailModel: any = new EventEmitter<any[]>();

  constructor() {}

  emitEdit() {
    this.output_editModel.emit(this.input_model);
  }
  emitDelete() {
    this.output_deleteModel.emit(this.input_model);
  }

  emitDetails() {
    this.output_detailModel.emit(this.input_model);
  }
}
